class RouteSummaryStock extends App.Collections.BaseCollection {
    url = '';
    model = App.Models.StockLine;
}

App.Collections.RouteSummaryStock = RouteSummaryStock;
